// ============================================================
// C2：高清出图抓取注册表（SceneCanvas 内部注册 gl/scene/camera 实现）
// 与缩略图抓取（sceneThumbnailStore）分离：支持分辨率/格式/视角参数
// ============================================================

export interface SceneImageCaptureOptions {
  width: number;
  height: number;
  format?: 'png' | 'jpeg';
  quality?: number;
  /** 指定导出视角（position/target）；缺省=当前视角 */
  view?: { position: [number, number, number]; target: [number, number, number] };
}

export type SceneImageCaptureFn = (opts: SceneImageCaptureOptions) => string | null;

export const sceneImageExportRegistry: {
  capture: SceneImageCaptureFn | null;
  /** G3：获取 WebGL canvas（录屏用） */
  getCanvas: (() => HTMLCanvasElement | null) | null;
} = {
  capture: null,
  getCanvas: null,
};
